'use client'

import * as React from 'react'

import BlockIcon from '@mui/icons-material/Block'
import { Box, Button, Stack, Typography } from '@mui/material'

import { useTrackEvent } from '@/hooks/useTrackEvent'
import { useTranslations } from '@/hooks/useTranslations'

interface Props {
  error: Error & { digest?: string }
  reset: () => void
}

export const ErrorBoundary = ({ error, reset }: Props) => {
  const { translate } = useTranslations()
  const { trackError } = useTrackEvent()

  React.useEffect(() => {
    trackError(error, 'error-boundary')
  }, [error, trackError])

  return (
    <Box component="main" sx={{ backgroundColor: 'background.body', py: 8 }}>
      <Stack spacing={3} alignItems="center" textAlign="center" sx={{ maxWidth: 480, mx: 'auto', px: 2 }}>
        <BlockIcon sx={{ fontSize: 64, color: 'error.main' }} />
        <Typography variant="h6" fontWeight="bold">
          {translate('common.error.somethingWentWrong.message')}
        </Typography>
        <Button variant="contained" onClick={reset}>
          {translate('common.error.somethingWentWrong.retry')}
        </Button>
      </Stack>
    </Box>
  )
}
